// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CountrySuggestDocument = `
    query countrySuggest {
  countrySuggest {
    isoCode
  }
}
    `;

export function useCountrySuggestQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.CountrySuggestQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.CountrySuggestQuery, SchemaTypes.CountrySuggestQueryVariables | undefined>({ query: CountrySuggestDocument, variables: undefined, ...options });
};